"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var apiConfig_1 = require("./apiConfig");
/**
 * 聪明派API客户端
 *
 * @class ApiClient
 */
var AuthApiClient = /** @class */ (function (_super) {
    __extends(AuthApiClient, _super);
    function AuthApiClient() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * 微信OAuth鉴权
     */
    AuthApiClient.prototype.authorizeWithWechat = function (code) {
        return __awaiter(this, void 0, void 0, function () {
            var url, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = AuthApiClient.API_BASE_URL + "/auth/wechat?code=" + code;
                        return [4 /*yield*/, this.requestAdaptor({ url: url, method: 'GET' })];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res.data];
                }
            });
        });
    };
    /**
     * 获取用户信息
     *
     * @returns {Promise<User>}
     * @memberof ApiClient
     */
    AuthApiClient.prototype.getUserInfo = function (userUuid) {
        return __awaiter(this, void 0, void 0, function () {
            var url, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!userUuid) {
                            url = AuthApiClient.API_BASE_URL + "/users/current/profile";
                        }
                        else {
                            url = AuthApiClient.API_BASE_URL + "/users/" + userUuid + "/profile";
                        }
                        return [4 /*yield*/, this.requestAdaptor({ url: url, method: 'GET' })];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res.data];
                }
            });
        });
    };
    /**
     * 获取当前用户信息
     *
     * @returns {Promise<User>}
     * @memberof ApiClient
     */
    AuthApiClient.prototype.getCurrentUser = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = AuthApiClient.API_BASE_URL + "/users/current/profile";
                        return [4 /*yield*/, this.requestAdaptor({ url: url, method: 'GET' })];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res.data];
                }
            });
        });
    };
    /**
     * 发送手机登录验证码
     */
    AuthApiClient.prototype.requestCellphoneAuthVerifyCode = function (mobile) {
        return __awaiter(this, void 0, void 0, function () {
            var url, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = AuthApiClient.API_BASE_URL + "/auth/cellphone/sign-in/code";
                        return [4 /*yield*/, this.requestAdaptor({
                                url: url,
                                method: 'POST',
                                data: { mobile: mobile },
                            })];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res.data];
                }
            });
        });
    };
    /**
     * 获取手机验证码
     *
     * @param {string} cellphone
     * @returns {Promise<object>}
     * @memberof ApiClient
     */
    AuthApiClient.prototype.authorizeWithCellphone = function (cellphone) {
        return __awaiter(this, void 0, void 0, function () {
            var url, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = AuthApiClient.API_BASE_URL + "/auth/cellphone/bind/" + encodeURIComponent(cellphone);
                        return [4 /*yield*/, this.requestAdaptor({ url: url, method: 'GET' })];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res.data];
                }
            });
        });
    };
    /*
     * 获取用户关注状态
     */
    AuthApiClient.prototype.getUserSubscribingStatus = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = AuthApiClient.API_BASE_URL + "/users/wechat/subscription";
                        return [4 /*yield*/, this.requestAdaptor({ url: url, method: 'GET' })];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res.data.status];
                }
            });
        });
    };
    AuthApiClient.prototype.userLogin = function (code, encryptedData, iv, appId, client) {
        return __awaiter(this, void 0, void 0, function () {
            var url, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = AuthApiClient.API_BASE_URL + "/auth/wechat";
                        return [4 /*yield*/, this.requestAdaptor({
                                url: url,
                                method: 'POST',
                                data: {
                                    code: code,
                                    encryptedData: encryptedData,
                                    iv: iv,
                                    appId: appId,
                                    client: client,
                                },
                            })];
                    case 1:
                        res = _a.sent();
                        // TODO response type assert is required, remove console.warn after declared type
                        console.warn("Response type assert is required, path: /auth/wechat");
                        return [2 /*return*/, res];
                }
            });
        });
    };
    /**
     * weapp bind mobile, rename
     * 用户绑定手机号
     */
    AuthApiClient.prototype.bindMobile = function (code, encryptedData, iv, appId, client) {
        return __awaiter(this, void 0, void 0, function () {
            var url, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = AuthApiClient.API_BASE_URL + "/auth/cellphone/weapp/bind";
                        return [4 /*yield*/, this.requestAdaptor({
                                url: url,
                                method: 'POST',
                                data: {
                                    code: code,
                                    encryptedData: encryptedData,
                                    iv: iv,
                                    appId: appId,
                                    client: client,
                                },
                            })];
                    case 1:
                        res = _a.sent();
                        // TODO response type assert is required, remove console.warn after declared type
                        console.warn("Response type assert is required, path: /auth/wechat");
                        return [2 /*return*/, res];
                }
            });
        });
    };
    // 获取用户所有信息
    AuthApiClient.prototype.getUserDetail = function (userUuid) {
        return __awaiter(this, void 0, void 0, function () {
            var url, param, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!userUuid) {
                            url = AuthApiClient.API_BASE_URL + "/users/current/profile";
                        }
                        else {
                            url = AuthApiClient.API_BASE_URL + "/users/" + userUuid + "/profile";
                        }
                        param = {
                            url: url,
                            data: {
                                userUuid: userUuid,
                            },
                            method: 'GET',
                        };
                        return [4 /*yield*/, this.requestAdaptor(param)];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res.data];
                }
            });
        });
    };
    // @deprecated
    AuthApiClient.prototype.authByCellphoneWithCode = function (cellphone, code) {
        return __awaiter(this, void 0, void 0, function () {
            var url, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = AuthApiClient.API_BASE_URL + "/auth/cellphone/login/" + encodeURIComponent(cellphone) + "/verify/" + encodeURIComponent(code);
                        return [4 /*yield*/, this.requestAdaptor({ url: url, method: 'GET' })];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res.data];
                }
            });
        });
    };
    /**
     * 手机号登录
     *
     * @param cellphone
     * @param mobile
     */
    AuthApiClient.prototype.signInOrSignUpByCellphone = function (mobile, verifyCode, registerChannel, weappQueryString) {
        return __awaiter(this, void 0, void 0, function () {
            var url, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = AuthApiClient.API_BASE_URL + "/auth/cellphone/login";
                        if (weappQueryString) {
                            url = AuthApiClient.API_BASE_URL + "/auth/cellphone/login?" + weappQueryString;
                        }
                        return [4 /*yield*/, this.requestAdaptor({
                                url: url,
                                data: { mobile: mobile, verifyCode: verifyCode, registerChannel: registerChannel },
                                method: 'POST',
                            })];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res.data];
                }
            });
        });
    };
    /**
     * 手机号绑定
     *
     * @param cellphone
     * @param mobile
     */
    AuthApiClient.prototype.preBindUserWithMobile = function (mobile) {
        return __awaiter(this, void 0, void 0, function () {
            var url, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = AuthApiClient.API_BASE_URL + "/auth/cellphone/pre-bind";
                        return [4 /*yield*/, this.requestAdaptor({
                                url: url,
                                data: { mobile: mobile },
                                method: 'POST',
                            })];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res.data];
                }
            });
        });
    };
    /**
     * 用户地址
     *
     */
    AuthApiClient.prototype.getUserAddress = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = AuthApiClient.API_BASE_URL + "/users/address";
                        return [4 /*yield*/, this.requestAdaptor({
                                url: url,
                                method: 'GET',
                            })];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res.data];
                }
            });
        });
    };
    /**
     * 保存用户地址
     *
     * @param detail
     * @param province
     * @param city
     */
    AuthApiClient.prototype.saveUserAddress = function (parmas) {
        return __awaiter(this, void 0, void 0, function () {
            var url, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = AuthApiClient.API_BASE_URL + "/logistics/address";
                        return [4 /*yield*/, this.requestAdaptor({
                                url: url,
                                data: parmas,
                                method: 'POST',
                            })];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res.data];
                }
            });
        });
    };
    /**
     * 微信授权手机号登录注册
     *
     * @param cellphone
     * @param mobile
     */
    AuthApiClient.prototype.weappSignUpOrSignInByAuthMobile = function (code, encryptedData, iv, appId, client, weappQueryString) {
        return __awaiter(this, void 0, void 0, function () {
            var url, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = AuthApiClient.API_BASE_URL + "/auth/cellphone/weapp/login";
                        if (weappQueryString) {
                            url = AuthApiClient.API_BASE_URL + "/auth/cellphone/weapp/login?" + weappQueryString;
                        }
                        return [4 /*yield*/, this.requestAdaptor({
                                url: url,
                                data: {
                                    code: code,
                                    encryptedData: encryptedData,
                                    iv: iv,
                                    appId: appId,
                                    client: client,
                                },
                                method: 'POST',
                            })];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res.data];
                }
            });
        });
    };
    /*
     * 支付宝小程序授权获取用户信息
     */
    AuthApiClient.prototype.getAlipayMiniProgramUserInfo = function (appId, code, grantType) {
        return __awaiter(this, void 0, void 0, function () {
            var url, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = AuthApiClient.API_BASE_URL + "/auth/alipay";
                        return [4 /*yield*/, this.requestAdaptor({
                                url: url,
                                data: {
                                    appId: appId,
                                    code: code,
                                    grantType: grantType,
                                },
                                method: 'POST',
                            })];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res.data];
                }
            });
        });
    };
    /*
     * 支付宝小程序获取用户手机号信息
     */
    AuthApiClient.prototype.alipayMiniLogin = function (appId, response, sign, weappQueryString) {
        return __awaiter(this, void 0, void 0, function () {
            var url, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = AuthApiClient.API_BASE_URL + "/auth/cellphone/alipay/login";
                        if (weappQueryString) {
                            url = AuthApiClient.API_BASE_URL + "/auth/cellphone/alipay/login?" + weappQueryString;
                        }
                        return [4 /*yield*/, this.requestAdaptor({
                                url: url,
                                method: 'POST',
                                data: {
                                    appId: appId,
                                    response: response,
                                    sign: sign,
                                },
                            })];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res.data];
                }
            });
        });
    };
    return AuthApiClient;
}(apiConfig_1.ApiConfig));
exports.AuthApiClient = AuthApiClient;
//# sourceMappingURL=auth.js.map


//////////////////
// WEBPACK FOOTER
// ../core/dist/src/services/api/auth.js
// module id = 1037
// module chunks = 0